import React from 'react'
import { Link } from 'react-router-dom'
import { FaChevronRight } from "react-icons/fa";

function Breadcrumb({breadCrumbPayload}) {
    <nav className="flex items-center text-sm text-muted-foreground">
    {breadCrumbPayload.map((item, index) => (
      <span className="flex items-center" key={index}>
        <FaChevronRight className="h-4 w-4 mx-1" />
        {item.isActive ? (
          <span
            style={{
              backgroundImage: "linear-gradient(to right, #8A2BE2, #4B0082)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {item.title}
          </span>
        ) : (
          <Link href={item.url} className="hover:text-foreground">
            {item.title}
          </Link>
        )}
      </span>
    ))}
  </nav>
}

export default Breadcrumb;
